module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/sp/profile_page/primary_organization-4734331d3131ca682e1505cf99f5f3a0.png";